/* import __COLOCATED_TEMPLATE__ from './saml-form.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();